<template>
    <div class="pa-5 compact-form" v-if="activeTag">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeTag.name"
                    @input="updateField($event, 'name')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Description" | t }}</v-col>
            <v-col cols="6">
                <v-textarea
                    :value="activeTag.description"
                    @input="updateField($event, 'description')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                    rows="3"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "general-edit-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("TagStore", ["activeTag", "errorMessage", "loadingTagData"])
    },
    methods: {
        ...mapMutations("TagStore", ["updateActiveTagProperty"]),
        updateField(value, field) {
            this.updateActiveTagProperty({ prop: field, value: value });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
